import React from "react"
import { useTranslation } from "react-i18next"

function AttributeTable({ title, attributes, emptyLabel, nameLabel, valueLabel }) {
    if (!attributes?.length) {
        return (
            <div className="pp-matching-attribute-block">
                <div className="pp-matching-attribute-block__title">{title}</div>
                <div className="pp-matching-attribute-block__empty text-muted">{emptyLabel}</div>
            </div>
        )
    }

    return (
        <div className="pp-matching-attribute-block">
            <div className="pp-matching-attribute-block__title">{title}</div>
            <table className="table table-sm table-bordered pp-matching-attribute-table mb-0">
                <thead>
                    <tr>
                        <th>{nameLabel}</th>
                        <th>{valueLabel}</th>
                    </tr>
                </thead>
                <tbody>
                    {attributes.map((attribute) => (
                        <tr key={attribute.name}>
                            <td className="pp-matching-attribute-table__name">{attribute.name}</td>
                            <td
                                className="pp-matching-attribute-table__value pp-matching-detail-value"
                                title={attribute.value}
                            >
                                {attribute.value}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default function PPMatchingAttributeTables({
    customerAttributes,
    foreignAttributes,
    openaiReason,
    staffelInfo
}) {
    const [t] = useTranslation()
    const hasAttributes = customerAttributes.length > 0 || foreignAttributes.length > 0
    const hasStaffelInfo = !!staffelInfo?.staffel_reason

    if (!hasAttributes && !openaiReason && !hasStaffelInfo) {
        return null
    }

    return (
        <div className="pp-matching-attribute-section mb-3">
            {openaiReason && (
                <div className="pp-matching-openai-reason mb-3">
                    <div className="pp-matching-attribute-block__title">{t("matching.openai_reason")}</div>
                    <div className="pp-matching-openai-reason__text">{openaiReason}</div>
                </div>
            )}
            {hasStaffelInfo && (
                <div className="pp-matching-staffel-info text-muted mb-3">
                    <strong>{t("matching.staffel_info")}:</strong> {staffelInfo.staffel_reason}
                    {staffelInfo.staffel_source_productnr && (
                        <span>
                            {" "}
                            ({t("matching.staffel_source")}: {staffelInfo.staffel_source_productnr})
                        </span>
                    )}
                </div>
            )}
            {hasAttributes && (
                <div className="pp-matching-attribute-grid">
                    <AttributeTable
                        title={t("matching.customer_attributes")}
                        attributes={customerAttributes}
                        emptyLabel={t("matching.no_attributes")}
                        nameLabel={t("matching.attribute_name")}
                        valueLabel={t("matching.attribute_value")}
                    />
                    <AttributeTable
                        title={t("matching.foreign_shop_attributes")}
                        attributes={foreignAttributes}
                        emptyLabel={t("matching.no_attributes")}
                        nameLabel={t("matching.attribute_name")}
                        valueLabel={t("matching.attribute_value")}
                    />
                </div>
            )}
        </div>
    )
}
